import { initialState } from "../vendors.slice";

const resetVendors = () => {
    return initialState;
}

export default resetVendors;